import * as _ from "lodash";
import { Components } from "formiojs";

const NumberComponent = Components.components.number;

export default class MiproPatientAgeNumber extends NumberComponent  {

    static schema() {
        return NumberComponent.schema({
            type: "miproPatientAgeNumber",
            label: "Patient Age",
            key: "dbo.mipro.miproPatientAge",
            placeholder: "Enter Patient Age", 
            disabled: false, 
            input: true
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Patient Age",
            group: "basic",
            icon: "user-md",
            weight: 70,
            schema: MiproPatientAgeNumber.schema(),            
        };
    }
}

Components.addComponent("miproPatientAgeNumber", MiproPatientAgeNumber);